import React from 'react';

const getLable = (lable, t) => {
  let result = '';
  switch (lable) {
    case 'walking':
      result = `${t('walking')}`;
      break;
    case 'standing':
      result = `${t('standing')}`;
      break;
    case 'sitting':
      result = `${t('sitting')}`;
      break;
    case 'lying':
      result = `${t('lying')}`;
      break;
    case 'lyingOnRight':
      result = `${t('on_right')}`;
      break;
    case 'lyingOnLeft':
      result = `${t('on_left')}`;
      break;
    case 'lyingOnBack':
      result = `${t('on_back')}`;
      break;
    case 'lyingOnStomach':
      result = `${t('on_stomach')}`;
      break;
    case 'total':
      result = `${t('total')}`;
      break;
    case 'lyingTotal':
      result = `${t('total')}`;
      break;
    default:
      break;
  }
  return result;
};

const ChipCheckedActivity = (props) =>
  props.data.map((val, i) => {
    return (
      <div className='p-1' key={i}>
        <div className='items-center w-max'>
          <input
            type='checkbox'
            id={i}
            name='sleep'
            value={val.label}
            className='absolute w-8 h-8 opacity-0'
            onChange={(e) => props.onSelect(e)}
            checked={val.checked}
          />
          <div
            className={`relative rounded-3xl w-full p-4 h-8 flex flex-shrink-0 justify-center items-center mr-2 bg-chart-${val.label}`}
          >
            <svg
              className='hidden w-3 h-3 mr-2 pointer-events-none fill-current'
              version='1.1'
              viewBox='0 0 17 12'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g fill='none' fillRule='evenodd'>
                <g
                  transform='translate(-9 -11)'
                  fill={val.label === 'lyingOnStomach' ? '#4A4A4A' : '#FFFFFF'}
                  fillRule='nonzero'
                >
                  <path d='m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z' />
                </g>
              </g>
            </svg>
            <label
              htmlFor={i}
              className={`flex text-lg font-normal cursor-pointer select-none ${val.label === 'lyingOnStomach' && val.checked ? 'text-chip' : 'text-white'}`}
            >
              {getLable(val.label, props.t)}
            </label>
          </div>
        </div>
      </div>
    );
  });

export default ChipCheckedActivity;
